
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FuseUtils } from '@fuse/utils';
import { PushNotificationService } from 'app/main/pages/administration-area/services/pushnotification.service';
import { WebSocketService } from 'app/main/services/webSocket.service';
import { ApiService } from 'app/main/shared/services/api.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';

const ICE_SERVERS: RTCIceServer[] = [
    { urls: ['turn:51.178.80.88:3478'], credential: 'Idra2017', username: 'idra' },
    { urls: 'stun:stun.l.google.com:19302' }
];

const PEER_CONNECTION_CONFIG: RTCConfiguration = {
    iceServers: ICE_SERVERS
};

@Injectable({
    providedIn: 'root'
})
export class VideocallService implements Resolve<any>
{

    private videoCalls: Array<any>;
    contacts: any[];
    videocalls: any[];
    user: any;
    onVideocallSelected: BehaviorSubject<any>;
    onContactSelected: BehaviorSubject<any>;
    onVideocallsUpdated: Subject<any>;
    onUserUpdated: Subject<any>;
    onLeftSidenavViewChanged: Subject<any>;
    onRightSidenavViewChanged: Subject<any>;
    private pcPeers: RTCPeerConnectionWrapper[];

    constructor(
        private api: ApiService,
        private webSocketService: WebSocketService,
        private pushNotificationService: PushNotificationService
    ) {
        this.videoCalls = new Array<any>();
        this.onVideocallSelected = new BehaviorSubject(null);
        this.onContactSelected = new BehaviorSubject(null);
        this.onVideocallsUpdated = new Subject();
        this.onUserUpdated = new Subject();
        this.onLeftSidenavViewChanged = new Subject();
        this.onRightSidenavViewChanged = new Subject();
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return new Promise((resolve, reject) => {
            Promise.all([
                this.getContacts()
                // this.getVideocalls(),
                // this.getUser()
            ]).then(
                ([contacts, videocalls, user]) => {
                    this.contacts = contacts;
                    // this.videocalls = videocalls;
                    // this.user = user;
                    resolve();
                },
                reject
            );
        });
    }

    getContacts(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.getRequest('chat/videocall-contacts')
                .subscribe((response: any) => {
                    resolve(response.payload);
                }, (err: any) => {
                    console.log(err);
                }, () => {
                });
        });
    }

    getVideocall(contactId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.pushNotificationService.sendNotificationForVideocall(contactId)
                .subscribe((response: any) => {
                    const videocall = response;
                    console.log(videocall);
                }, reject);

        });
    }

    createNewVideocall(contactId): Promise<any> {
        return new Promise((resolve, reject) => {

            const contact = this.contacts.find((item) => {
                return item.id === contactId;
            });

            const videocallId = FuseUtils.generateGUID();

            const videocall = {
                id: videocallId,
                dialog: []
            };

            const videocallListItem = {
                contactId: contactId,
                id: videocallId,
                lastMessageTime: '2017-02-18T10:30:18.931Z',
                name: contact.name,
                unread: null
            };

            this.user.videocallList.push(videocallListItem);

            this.api.postRequest('chat/videocall-videocalls', { ...videocall })
                .subscribe((response: any) => {
                    this.api.postRequest('chat/videocall-user/' + this.user.id, this.user)
                        .subscribe(newUserData => {
                            this.getUser().then(updatedUser => {
                                this.onUserUpdated.next(updatedUser);
                                resolve(updatedUser);
                            });
                        });
                }, reject);
        });
    }

    selectContact(contact): void {
        this.onContactSelected.next(contact);
    }

    setUserStatus(status): void {
        this.user.status = status;
    }

    updateUserData(userData): void {
        this.api.postRequest('chat/videocall-user/' + this.user.id, userData)
            .subscribe((response: any) => {
                this.user = userData;
            }
            );
    }

    updateDialog(videocallId, dialog): Promise<any> {
        return new Promise((resolve, reject) => {
            const newData = {
                id: videocallId,
                dialog: dialog
            };
            this.api.postRequest('chat/videocall-videocalls/' + videocallId, newData)
                .subscribe(updatedVideocall => {
                    resolve(updatedVideocall);
                }, reject);
        });
    }

    getVideocalls(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.getRequest('chat/videocall-videocalls')
                .subscribe((response: any) => {
                    resolve(response.payload);
                }, (err: any) => {
                    console.log(err);
                }, () => {
                });
        });
    }

    getUser(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.getRequest('chat/videocall-user')
                .subscribe((response: any) => {
                    resolve(response.payload);
                }, (err: any) => {
                    console.log(err);
                }, () => {
                });
        });
    }

    public tryToContact(toUserId) {
        try {
            this.webSocketService.sendWebSocketMessage(
                WebSocketVideoCallToSendMessages.TRY_TO_CONTACT_USER_FOR_VIDEO_CALL,
                WebSocketVideoCallToSendMessages.TRY_TO_CONTACT_USER_FOR_VIDEO_CALL, {
                    toUserId: toUserId,
                    userUuid: toUserId,
                    randomId: Math.floor(Math.random() * 10000000000000),
                    timestamp: new Date().getTime()
                });

        } catch (ex) {
            console.log('errore trytoconnect', ex);
        }
    }

    public createRTCPeerConnection(toUserId, isOffer, contactId, onTrackCallback, localStream) {
        const pc = new RTCPeerConnection(PEER_CONNECTION_CONFIG);
        if (!this.pcPeers) {
            this.pcPeers = [];
        }
        pc.onicecandidate = this.getIceCandidateCallback(contactId);
        pc.oniceconnectionstatechange = (event) => {
            if (!environment.production) {
                console.log('oniceconnectionstatechange', pc.iceConnectionState);
            }
            if (pc.iceConnectionState === 'disconnected') {
                this.closePeerConnection(contactId);
            }
        };

        pc.ontrack = onTrackCallback;

        pc.onnegotiationneeded = () => {
            if (pcWrapper.negotiating) {
                return;
            }
            pcWrapper.negotiating = true;
            if (isOffer) {
                this.createOffer(pc, toUserId);
            }
        };
        if (localStream) {
            for (const track of localStream.getTracks()) {
                pc.addTrack(track);
            }
        }
        const pcWrapper = new RTCPeerConnectionWrapper();
        pcWrapper.rtcPeerConnection = pc;
        this.pcPeers[toUserId] = pcWrapper;

        return pc;
    }

    private getIceCandidateCallback(contactId): (string) => void {
        return (event) => {
            if (!environment.production) {
                console.log(`got ice candidate:`, event);
            }
            if (event.candidate != null) {
                this.webSocketService.sendWebSocketMessage(
                    WebSocketVideoCallToSendMessages.SEND_VIDEO_CALL_MESSAGE,
                    WebRTCStatus.EXCHANGE,
                    {
                        toUserId: contactId,
                        candidate: event.candidate
                    });
            }
        };
    }

    public closePeerConnection(toUserId) {
        if (this.pcPeers) {
            const pcWrapper = this.pcPeers[toUserId];
            if (pcWrapper) {
                const pc = pcWrapper.rtcPeerConnection;
                if (pc) {
                    pc.close();
                    delete this.pcPeers[toUserId];
                }
            }
        }
    }

    private createOffer(pc, toUserId) {
        pc.createOffer().then((desc) => {
            if (!environment.production) {
                console.log('createOffer', desc);
            }
            pc.setLocalDescription(desc).then(() => {
                if (!environment.production) {
                    console.log('setLocalDescription', pc.localDescription);
                }
                this.webSocketService.sendWebSocketMessage(
                    WebSocketVideoCallToSendMessages.SEND_VIDEO_CALL_MESSAGE,
                    WebRTCStatus.EXCHANGE,
                    {
                        toUserId: toUserId,
                        sdp: pc.localDescription
                    }
                );
            }).catch(ex1 => {
                console.log(ex1);
            });
        }).catch(ex => {
            console.log(ex);
        });
    }

    public exchange(data, contactId, onTrackCallback, localStream) {
        const fromId = data.from;
        let pc;
        if (this.pcPeers && fromId in this.pcPeers) {
            const pcWrapper = this.pcPeers[fromId];
            pc = pcWrapper.rtcPeerConnection;
        } else {
            if (!environment.production) {
                console.log('call createRTCPeerConnection - exchange');
            }
            pc = this.createRTCPeerConnection(fromId, false, contactId, onTrackCallback, localStream);
        }
        if (data.sdp) {
            if (!environment.production) {
                console.log('exchange sdp', data);
            }
            pc.setRemoteDescription(new RTCSessionDescription(data.sdp)).then(() => {
                if (pc.remoteDescription.type === 'offer') {
                    if (!environment.production) {
                        console.log('offer');
                    }
                    // if (pc.signalingState !== 'have-remote-offer' && pc.signalingState !== ' have-local-pranswer') {
                    //     return;
                    // }
                    pc.createAnswer().then((desc) => {
                        if (!environment.production) {
                            console.log('createAnswer', desc);
                        }
                        // if (pc.signalingState === 'stable') {
                        //     return;
                        // }
                        pc.setLocalDescription(desc).then(() => {
                            if (!environment.production) {
                                console.log('setLocalDescription', pc.localDescription);
                            }
                            this.webSocketService.sendWebSocketMessage(
                                WebSocketVideoCallToSendMessages.SEND_VIDEO_CALL_MESSAGE,
                                WebRTCStatus.EXCHANGE,
                                {
                                    to: fromId,
                                    sdp: pc.localDescription
                                });
                        }).catch((err) => {
                            console.log('error ', err);
                        });
                    }).catch((err) => {
                        console.log('error ', err);
                    });
                }
            }).catch((err) => {
                console.log('error ', err);
            });
        } else if (data.candidate) {
            if (!environment.production) {
                console.log('exchange candidate', data);
            }
            pc.addIceCandidate(new RTCIceCandidate(data.candidate)).catch(ex => { console.log(ex); console.log(data.candidate); });
        }
    }

    addVideo(currentContact: { contactId: string; socketSessionId: any; }, isEmergency: boolean, emergencyId: string, isRosCam: boolean) {
        console.log('VideoCallService addVideo');
        const idx = this.videoCalls.findIndex(x => x.contactId === currentContact.contactId);
        const newVid = {
            contactId: currentContact.contactId,
            socketSessionId: currentContact.socketSessionId,
            isEmergency: isEmergency,
            emergencyId: emergencyId
        };
        if (idx < 0) {
            this.videoCalls.push(newVid);
        } else {
            this.videoCalls.splice(idx, 1, newVid);
        }
        console.log('VideoCallService addVideo', this.videoCalls);
    }

    removeVideo(currentContact: { contactId: string; socketSessionId: any; }) {
        console.log('VideoCallService removeVideo');
        if (!currentContact) {
            return;
        }
        const idx = this.videoCalls.findIndex(x => x.socketSessionId === currentContact.socketSessionId);
        if (idx > 0) {
            this.videoCalls.splice(idx, 1);
        } else {
            console.log('VideoCallService removeVideo not found', idx, currentContact);
        }
        console.log('VideoCallService removeVideo', this.videoCalls);

    }

    removeAllVideo() {
        this.videoCalls = new Array<any>();
        console.log('VideoCallService removeAllVideo');
    }

    isInCall(): boolean {
        return this.videoCalls.length > 0;
    }

    getCurrentContacts() {
        return this.videoCalls;
    }
}

// intentionally enum not used (problem with key...toString()...)
export class WebSocketVideoCallToSendMessages {
    public static TRY_TO_CONTACT_USER_FOR_VIDEO_CALL = 'TRY_TO_CONTACT_USER_FOR_VIDEO_CALL';
    public static SEND_VIDEO_CALL_MESSAGE = 'SEND_VIDEO_CALL_MESSAGE';
}

// intentionally enum not used (problem with key...toString()...)
export class WebSocketVideoCallToReceiveMessages {
    public static USER_AVAILABLE_FOR_VIDEO_CALL = 'USER_AVAILABLE_FOR_VIDEO_CALL';
    public static USER_NOT_AVAILABLE_FOR_VIDEO_CALL = 'USER_NOT_AVAILABLE_FOR_VIDEO_CALL';
    public static SEND_VIDEO_CALL_MESSAGE_ACKNOWLEDGEMENT = 'SEND_VIDEO_CALL_MESSAGE_ACKNOWLEDGEMENT';
}

// intentionally enum not used (problem with key...toString()...)
export class WebRTCStatus {
    public static EXCHANGE = 'exchange';
    public static LEAVE = 'leave';
}

export class RTCPeerConnectionWrapper {
    public rtcPeerConnection: RTCPeerConnection;
    // tslint:disable-next-line:no-inferrable-types
    public negotiating: boolean = false;
}
